import { yup } from '@guiker/yup-util'

export const listingUidNested = yup.object({
  listingUid: yup.string().required(),
})

export type ListingUidNested = yup.InferType<typeof listingUidNested>
